// extracted by mini-css-extract-plugin
export default {"projetosContainer":"Projetos_projetosContainer__QRTLx","titulo":"Projetos_titulo__2DlDP","posts":"Projetos_posts__hpaoc"};